import type { UserRevokedAction } from '@Application/Security/Authentications/Actions/userRevoked';
import type { ContactRelationshipsFetchedAction } from '@Application/Beneficiaries/BeneficiaryContacts/ContactRelationships/Actions/contactRelationshipsFetched';
import LabeledValueView from '@UI/Store/Shared/Views/LabeledValueView';
import { createSliceReducer, registerStore } from '@verclam/synapse';

export type ContactRelationshipsStore = {
	contactRelationships: readonly LabeledValueView[] | null;
};

const initialState: ContactRelationshipsStore = {
	contactRelationships: null,
};

type Actions = ContactRelationshipsFetchedAction | UserRevokedAction;

const whenContactRelationshipsFetched = (
	store: ContactRelationshipsStore,
	action: ContactRelationshipsFetchedAction,
): ContactRelationshipsStore => ({
	...store,
	contactRelationships: action.payload.map((entry) => new LabeledValueView(entry)),
});

// A catalog of labels has no reason to survive a session: the next session refetches it.
const whenUserRevoked = (): ContactRelationshipsStore => initialState;

export default registerStore<'contactRelationshipsStore', Actions>(
	'contactRelationshipsStore',
	createSliceReducer({
		CONTACT_RELATIONSHIPS_FETCHED: whenContactRelationshipsFetched,
		USER_REVOKED: whenUserRevoked,
	}),
	initialState,
);
